module.exports = __webpack_public_path__ + "img/2008.10.1cb56c23.png";